module.exports = __webpack_public_path__ + "static/bg_space-b499cc1077821e9900d200f262e5f81d.jpg";